// libs, helpers, services
import { hasMatchRoutes, hasMatchSubRoutes } from '@/helpers/verify-routes';
import store from '@/store';
import { createRouter, createWebHistory } from 'vue-router';
// auth
import Layout from '@/views/Layout';
import AppLogin360 from '@/views/login/AppLogin360.vue';
import LoginOto from '@/views/LoginOto';
// welcome
import Welcome from '@/views/Welcome';
// dashboard
import FullView from '@/views/dashboards-o2o/FullView';
// audience
import Audience from '@/views/Audience';
import AudienceManagement from '@/views/AudienceManagement';
// campaigns
import Campaigns from '@/views/Campaigns';
import CampaignsDetails from '@/views/CampaignsDetails';
// campaigns email
import CampaignEmail from '@/views/email-campaign/CampaignEmail.vue';
import CampaignEmailForm from '@/views/email-campaign/CampaignEmailForm.vue';
//import CampaignEmailDeliverability from './views/email-deliverability/CampaignEmailDeliverability.vue';
//import EmailResults from '@/views/email/EmailResults.vue';
// products
import Category from '@/views/Category';
import Product from '@/views/Product';
import ProductsDashboard from '@/views/ProductsDashboard';
import ProductsList from '@/views/ProductsList';
// reports
import Reports from '@/views/help/Reports';
import ReportsList from '@/views/help/ReportsList';
// glossary
import Glossary from '@/views/help/Glossary';

// oto
import CashbackDetail from '@/views/oto/CashbackDetail';
import CashbackReport from '@/views/oto/CashbackReport';
import RegistrationCulture from '@/views/RegistrationCulture';
import PushNotifications from '@/views/store/PushNotifications.vue';
import PushNotificationsDetail from '@/views/store/PushNotificationsDetail.vue';
import Sellers from '@/views/store/Sellers.vue';

// Base Management
import AudienceManager from '@/views/base-management/AudienceManager';
import CustomerDistribution from '@/views/base-management/CustomerDistribution';
import CustomerDistributionEdit from '@/views/base-management/CustomerDistributionEdit';
import Customers from '@/views/base-management/Customers';
import CustomerView from '@/views/base-management/CustomerView';
import Rfv from '@/views/base-management/Rfv.vue';

// campaigns
import ActionsAttachments from '@/views/campaigns/ActionsAttachments';
import ActionsMessages from '@/views/campaigns/ActionsMessages';
import CampaignsManagementNew from '@/views/campaigns/CampaignsManagement.vue';
import CampaignsManagementEdit from '@/views/campaigns/CampaignsManagementEdit.vue';
import EngagementReport from '@/views/campaigns/EngagementReport';
import SalesReportNew from '@/views/campaigns/SalesReportNew.vue';

// settings
import Settings from '@/views/Settings';
// settings components
import CustomFields from '@/components/settings/customFields/CustomFields';
import Integrations from '@/components/settings/Integrations';
import IntegrationCreateEdit from '@/components/settings/integrations/IntegrationCreateEdit';
import Limits from '@/components/settings/Limits';
import Metrics from '@/components/settings/Metrics';
import Preferences from '@/components/settings/Preferences';
import Security from '@/components/settings/Security';
import SendUsage from '@/components/settings/SendUsage';
import StoreSettings from '@/components/settings/stores/StoreSettings.vue';
import StoreSettingsTable from '@/components/settings/stores/StoreSettingsTable';
import StoresSettingsRegister from '@/components/settings/stores/StoresSettingsRegister';
import Users from '@/components/settings/Users';
// stores
import Stores from '@/views/Stores';
// labels
import LabelDetail from '@/views/LabelDetail';
import Labels from '@/views/Labels';

// personas
import Personas from '@/views/Personas';
import PersonasCompare from '@/views/PersonasCompare';
import PersonasDashboard from '@/views/PersonasDashboard';
import PersonasDetail from '@/views/PersonasDetail';

// data and Integrations
import DataInconsistency from '@/views/connect/DataInconsistency';
import DataIngestionHistory from '@/views/connect/DataIngestionHistory';
import HistoryExport from '@/views/connect/HistoryExport';
import HistoryImport from '@/views/connect/HistoryImport';
import RawDataAccess from '@/views/connect/RawDataAccess';
import RockinTags from '@/views/connect/RockinTags';

// Oto Academy
import LandingPageOtoAcademy from '@/views/LandingPageOtoAcademy';

// SMS
import SMSCampaignsList from '@/views/sms/SMSCampaignsList.vue';
import SMSCampaignsCreate from '@/views/sms/SMSCampaignsCreate.vue';

const routes = [
  {
    path: '/',
    name: '',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Welcome',
        component: Welcome,
        meta: {
          title: 'welcome',
        },
      },
      {
        path: 'oto-academy',
        name: 'oto-academy',
        component: LandingPageOtoAcademy,
        meta: {
          title: 'oto-academy',
          breadcrumb: [{ name: 'oto-academy', link: '/oto-academy' }],
        },
      },
      // Start analytics
      {
        path: 'analytics/o2o',
        name: 'analytics-o2o',
        component: FullView,
        meta: {
          title: 'analytics.analytics-o2o',
          breadcrumb: [{ name: 'analytics.index' }, { name: 'analytics.analytics-o2o', link: '/analytics/o2o' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('analytics', 'analytics-o2o')) next();
          else next('/');
        },
      },
      // End analytics
      // Start products
      {
        path: 'analytics/products',
        name: 'analytics-products',
        component: ProductsDashboard,
        meta: {
          title: 'analytics.analytics-products',
          breadcrumb: [{ name: 'analytics.index' }, { name: 'analytics.products', link: '/analytics/products' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('analytics', 'analytics-products')) next();
          else next('/');
        },
      },
      {
        path: 'analytics/products/search',
        name: 'productsList',
        component: ProductsList,
        props: route => ({ term: route.query.term }),
        meta: {
          title: 'analytics.analytics-products',
          breadcrumb: [
            { name: 'analytics.index' },
            { name: 'analytics.products', link: '/analytics/products' },
            { name: 'analytics.products-search' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchRoutes('products') || hasMatchSubRoutes('analytics', 'analytics-products')) next();
          else next('/');
        },
      },
      {
        path: 'analytics/products/:id',
        name: 'product',
        component: Product,
        meta: {
          title: 'analytics.analytics-products',
          breadcrumb: [
            { name: 'analytics.index' },
            { name: 'analytics.products', link: '/analytics/products' },
            { name: 'analytics.product-detail' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchRoutes('products') || hasMatchSubRoutes('analytics', 'analytics-products')) next();
          else next('/');
        },
      },
      {
        path: 'analytics/products/categories/:name',
        name: 'category',
        component: Category,
        meta: {
          title: 'analytics.analytics-products',
          breadcrumb: [
            { name: 'analytics.index' },
            { name: 'analytics.products', link: '/analytics/products' },
            { name: 'analytics.category-detail' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchRoutes('products') || hasMatchSubRoutes('analytics', 'analytics-products')) next();
          else next('/');
        },
      },
      // End products
      // Start store
      {
        path: 'analytics/stores',
        name: 'analytics-stores',
        component: Stores,
        meta: {
          title: 'analytics.analytics-stores',
          breadcrumb: [{ name: 'analytics.index' }, { name: 'analytics.stores', link: '/analytics/stores' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('analytics', 'analytics-stores')) next();
          else next('/');
        },
      },
      // End store

      // Start audience v1
      {
        path: '/new-audiences',
        name: 'new-audience-activation',
        component: AudienceManagement,
        props: route => ({ t: route.query.page }),
        meta: {
          title: 'audiences',
          breadcrumb: [{ name: 'audience-mgmt' }, { name: 'audience.list', link: '/new-audiences' }],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('audience-mgmt', 'new-audience-activation')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/base-audiences',
        name: 'base-audiences',
        component: AudienceManagement,
        props: route => ({ t: route.query.page }),
        meta: {
          title: 'audiences',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.audiences', link: '/base-management/base-audiences' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-audiences')) next();
          else next('/');
        },
      },
      {
        path: 'new-audiences/create',
        name: 'AudienceCreate',
        component: Audience,
        props: true,
        meta: {
          title: 'create-audience',
          breadcrumb: [
            { name: 'audience-mgmt' },
            { name: 'audience.list', link: '/new-audiences' },
            { name: 'audience.create' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('audience-mgmt', 'new-audience-activation')) next();
          else next('/');
        },
      },
      {
        path: 'new-audiences/create/:id',
        name: 'AudienceDuplicate',
        component: Audience,
        props: true,
        meta: {
          title: 'duplicate-audience',
          breadcrumb: [
            { name: 'audience-mgmt' },
            { name: 'audience.list', link: '/new-audiences' },
            { name: 'audience.duplicate' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('audience-mgmt', 'new-audience-activation')) next();
          else next('/');
        },
      },
      {
        path: 'new-audiences/view/:creator/:id',
        name: 'AudienceDetail',
        component: Audience,
        props: true,
        meta: {
          title: 'view-audience',
          breadcrumb: [
            { name: 'audience-mgmt' },
            { name: 'audience.list', link: '/new-audiences' },
            { name: 'audience.detail' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('audience-mgmt', 'new-audience-activation')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/base-audiences/create',
        name: 'AudienceCreateNew',
        component: AudienceManager,
        props: true,
        meta: {
          title: 'create-audience',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.audiences', link: '/base-management/base-audiences' },
            { name: 'audience.create' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-audiences')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/base-audiences/create/:id',
        name: 'AudienceDuplicateNew',
        component: AudienceManager,
        props: true,
        meta: {
          title: 'duplicate-audience',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.audiences', link: '/base-management/base-audiences' },
            { name: 'audience.duplicate' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-audiences')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/base-audiences/view/:creator/:id',
        name: 'AudienceDetailNew',
        component: AudienceManager,
        props: true,
        meta: {
          title: 'view-audience',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.audiences', link: '/base-management/base-audiences' },
            { name: 'audience.detail' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-audiences')) next();
        },
      },
      // End audience v1

      // Start campaigns
      {
        path: 'performance/campaigns',
        name: 'performance-audiences',
        component: Campaigns,
        props: route => ({ t: route.query.page }),
        meta: {
          title: 'campaigns',
          breadcrumb: [{ name: 'performance' }, { name: 'campaign.list', link: '/performance/campaigns' }],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('performance', 'performance-audiences')) next();
          else next('/');
        },
      },
      {
        path: 'performance/campaigns/create',
        name: 'campaignsCreate',
        component: Campaigns,
        meta: { title: 'campaigns', isModal: true },
      },
      {
        path: 'performance/campaigns/:id',
        name: 'campaignsDetails',
        component: CampaignsDetails,
        props: true,
        meta: {
          title: 'campaigns',
          breadcrumb: [
            { name: 'performance' },
            { name: 'campaign.list', link: '/performance/campaigns' },
            { name: 'campaign.detail' },
          ],
        },
        beforeEnter: (to, from, next) => {
          if (hasMatchSubRoutes('performance', 'performance-audiences')) next();
          else next('/');
        },
      },
      // End campaigns

      // Start E-mail
      {
        path: 'email/email-campaign-list',
        name: 'email-campaign-list',
        component: CampaignEmail,
        meta: {
          title: 'email.email-campaign-list',
          breadcrumb: [{ name: 'email.index' }, { name: 'email.email-campaign-list' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('email', 'email-campaign-list')) return next();
          else next('/');
        },
      },
      /*
      {
        path: 'email/email-results',
        name: 'email-results',
        component: EmailResults,
        props: false,
        meta: {
          title: 'email.email-results',
          breadcrumb: [{ name: 'email.index' }, { name: 'email.email-results' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('email', 'email-results')) next();
          else next('/');
        },
      },
      {
        path: 'email/email-deliverability',
        name: 'email-deliverability',
        component: CampaignEmailDeliverability,
        props: route => ({ mode: 'edit', id: route.params.id }),
        meta: {
          title: 'email.email-deliverability',
          breadcrumb: [{ name: 'email.index' }, { name: 'email.email-deliverability' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('email', 'email-deliverability')) next();
          else next('/');
        },
      },
      */
      {
        path: 'email/email-campaign-list/create',
        name: 'email.campaign-create',
        component: CampaignEmailForm,
        props: { mode: 'create' },
        meta: {
          title: 'email.email-campaign-create',
          breadcrumb: [
            { name: 'email.index' },
            { name: 'email.email-campaign-list', link: '/email/email-campaign-list' },
            { name: 'email.email-campaign-create' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('email', 'email-campaign-list')) next();
          else next('/');
        },
      },
      {
        path: 'email/email-campaign-list/edit/:id',
        name: 'email.campaigns.edit',
        component: CampaignEmailForm,
        props: route => ({ mode: 'edit', id: route.params.id }),
        meta: {
          title: 'email.email-campaign-edit',
          breadcrumb: [
            { name: 'email.index' },
            { name: 'email.email-campaign-list', link: '/email/email-campaign-list' },
            { name: 'email.email-campaign-edit' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('email', 'email-campaign-list')) next();
          else next('/');
        },
      },
      // End E-mail

      // Start cdp / integrations
      {
        path: 'connect/connect-tags',
        name: 'connect-tags',
        component: RockinTags,
        meta: {
          title: 'connect-tags',
          breadcrumb: [
            { name: 'integrations.title' },
            { name: 'integrations.connect-tags', link: '/connect/connect-tags' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('integrations', 'connect-tags')) next();
          else next('/');
        },
      },
      {
        path: 'connect/import',
        name: 'connect-import',
        component: HistoryImport,
        meta: {
          title: 'connect-import',
          breadcrumb: [{ name: 'integrations.title' }, { name: 'integrations.connect-import' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('integrations', 'connect-import')) next();
          else next('/');
        },
      },
      {
        path: 'connect/export',
        name: 'connect-export',
        component: HistoryExport,
        meta: {
          title: 'connect-export',
          breadcrumb: [{ name: 'integrations.title' }, { name: 'integrations.connect-export' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('integrations', 'connect-export')) next();
          else next('/');
        },
      },
      {
        path: 'connect/raw-data-access',
        name: 'connect-raw-data-access',
        component: RawDataAccess,
        meta: {
          title: 'connect-raw-data-access',
          breadcrumb: [{ name: 'integrations.title' }, { name: 'integrations.connect-raw-data-access' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('integrations', 'connect-raw-data-access')) next();
          else next('/');
        },
      },
      {
        path: 'connect/data-ingestion-history',
        name: 'connect-data-ingestion-history',
        component: DataIngestionHistory,
        meta: {
          title: 'connect-data-ingestion-history',
          breadcrumb: [{ name: 'integrations.title' }, { name: 'integrations.connect-data-ingestion-history' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('integrations', 'connect-data-ingestion-history')) next();
        },
      },
      {
        path: 'connect/data-inconsistency',
        name: 'connect-data-inconsistency',
        component: DataInconsistency,
        meta: {
          title: 'connect-data-inconsistency',
          breadcrumb: [{ name: 'integrations.title' }, { name: 'integrations.connect-data-inconsistency' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('integrations', 'connect-data-inconsistency')) next();
          else next('/');
        },
      },
      // End cdp / integrations

      // Start Campaigns
      {
        path: 'campaigns/campaign-sales-report',
        name: 'campaign-sales-report',
        component: SalesReportNew,
        meta: {
          showModal: false,
          title: 'campaigns.sales-report',
          breadcrumb: [{ name: 'campaigns.index' }, { name: 'campaigns.sales-report' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-sales-report')) next();
          else next('/');
        },
      },
      {
        path: 'campaigns/campaign-engagement',
        name: 'campaign-engagement',
        component: EngagementReport,
        meta: {
          title: 'campaigns.engagement-report',
          breadcrumb: [
            { name: 'campaigns.index' },
            { name: 'campaigns.engagement-report', link: '/campaigns/campaign-engagement' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-engagement')) next();
          else next('/');
        },
      },
      {
        path: 'campaigns/attachments',
        name: 'campaign-attachments',
        component: ActionsAttachments,
        meta: {
          showModal: false,
          title: 'campaigns.attachments',
          breadcrumb: [{ name: 'campaigns.index' }, { name: 'campaigns.attachments' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-attachments')) next();
          else next('/');
        },
      },
      {
        path: 'campaigns/messages',
        name: 'campaign-messages',
        component: ActionsMessages,
        meta: {
          showModal: false,
          title: 'campaigns.messages',
          breadcrumb: [{ name: 'campaigns.index' }, { name: 'campaigns.messages' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-messages')) next();
          else next('/');
        },
      },
      {
        path: 'campaigns/campaigns',
        name: 'campaign-campaigns',
        component: CampaignsManagementNew,
        meta: {
          title: 'campaigns.campaigns',
          breadcrumb: [{ name: 'campaigns.index' }, { name: 'campaigns.campaigns' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-campaigns')) next();
          else next('/');
        },
      },
      {
        path: 'campaigns/campaigns/create',
        name: 'campaign-campaigns-create',
        component: CampaignsManagementEdit,
        props: { mode: 'create' },
        meta: {
          title: 'campaigns.campaign-create',
          breadcrumb: [
            { name: 'campaigns.index' },
            { name: 'campaigns.campaigns', link: '/campaigns/campaigns' },
            { name: 'campaigns.campaign-create' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-campaigns')) next();
          else next('/');
        },
      },
      {
        path: 'campaigns/campaigns/edit/:id',
        name: 'campaign-campaigns-edit',
        component: CampaignsManagementEdit,
        props: route => ({ mode: 'edit', id: route.params.id }),
        meta: {
          title: 'campaigns.campaign-edit',
          breadcrumb: [
            { name: 'campaigns.index' },
            { name: 'campaigns.campaigns', link: '/campaigns/campaigns' },
            { name: 'campaigns.campaign-edit' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('campaigns', 'campaign-campaigns')) next();
          else next('/');
        },
      },
      // End Campaigns

      // Start SMS
      {
        path: 'sms/campaign-sms',
        name: 'campaign-sms',
        component: SMSCampaignsList,
        meta: {
          title: 'sms.campaign',
          breadcrumb: [{ name: 'sms.index' }, { name: 'sms.campaigns' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('sms', 'campaign-sms')) next();
          else next('/');
        },
      },
      {
        path: 'sms/campaign-sms/create',
        name: 'campaign-sms-create',
        component: SMSCampaignsCreate,
        meta: {
          title: 'sms.campaign',
          breadcrumb: [
            { name: 'sms.index' },
            { name: 'sms.campaigns', link: '/sms/campaign-sms' },
            { name: 'sms.create' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('sms', 'campaign-sms')) next();
          else next('/');
        },
      },
      // End SMS

      // Start store
      {
        path: 'store/sellers',
        name: 'store-management-sellers',
        component: Sellers,
        meta: {
          showModal: false,
          title: 'store-management-sellers',
          breadcrumb: [{ name: 'store.index' }, { name: 'store.management-sellers' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('store', 'store-management-sellers')) next();
          else next('/');
        },
      },
      {
        path: 'store/sellers/:sellerId',
        name: 'store-management-sellers-detail',
        component: Sellers,
        meta: {
          showModal: true,
          title: 'store-management-sellers',
          breadcrumb: [{ name: 'store.index' }, { name: 'store.management-sellers' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('store', 'store-management-sellers')) next();
          else next('/');
        },
      },
      {
        path: 'store/push',
        name: 'store-management-push',
        component: PushNotifications,
        meta: {
          showModal: false,
          title: 'store-management-push',
          breadcrumb: [{ name: 'store.index' }, { name: 'store.management-push.index' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('store', 'store-management-push')) next();
          else next('/');
        },
      },
      {
        path: 'store/push/create',
        name: 'store-management-push-create',
        props: () => ({ mode: 'create' }),
        component: PushNotificationsDetail,
        meta: {
          showModal: false,
          title: 'store-management-push-create',
          breadcrumb: [
            { name: 'store.index' },
            { name: 'store.management-push.index', link: '/store/push' },
            { name: 'store.management-push.create' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('store', 'store-management-push')) next();
          else next('/');
        },
      },
      {
        path: 'store/push/edit/:id',
        name: 'store-management-push-edit',
        component: PushNotificationsDetail,
        props: route => ({ mode: 'edit', id: route.params.id }),
        meta: {
          title: 'store-management-push-edit',
          breadcrumb: [
            { name: 'store.index' },
            { name: 'store.management-push.index', link: '/store/push' },
            { name: 'store.management-push.edit' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('store', 'store-management-push')) next();
          else next('/');
        },
      },
      {
        path: 'store/push/view/:id',
        name: 'store-management-push-detail',
        component: PushNotificationsDetail,
        props: route => ({ mode: 'view', id: route.params.id }),
        meta: {
          title: 'store-management-push-detail',
          breadcrumb: [
            { name: 'store.index' },
            { name: 'store.management-push.index', link: '/store/push' },
            { name: 'store.management-push.detail' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('store', 'store-management-push')) next();
          else next('/');
        },
      },
      // End store

      // Start cashback
      {
        path: 'cashback/cashback',
        name: 'cashback-cashback',
        component: CashbackDetail,
        meta: {
          title: 'cashback-cashback',
          breadcrumb: [{ name: 'cashback.index' }, { name: 'cashback.cashback' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('cashback', 'cashback-cashback')) next();
          else next('/');
        },
      },
      {
        path: 'cashback/cashback-report',
        name: 'cashback-report',
        component: CashbackReport,
        meta: {
          showModal: false,
          title: 'cashback-report',
          breadcrumb: [{ name: 'cashback.index' }, { name: 'cashback.cashback-report' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('cashback', 'cashback-report')) next();
          else next('/');
        },
      },
      // End cashback

      //// Start Base Management
      // Customers
      {
        path: 'base-management/customers',
        name: 'base-customers',
        component: Customers,
        props: false,
        meta: {
          title: 'base-management.customers',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.customers', link: '/base-management/customers' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-customers')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/customers/search',
        name: 'base-management-customers-search',
        component: Customers,
        props: route => ({ t: route.query.t }),
        meta: {
          title: 'base-management.search-results',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.customers', link: '/base-management/customers' },
            { name: 'base-management.search-results' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-customers')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/customers/customerview/:id?',
        name: 'base-management-customerview-id',
        component: CustomerView,
        props: true,
        meta: {
          title: 'base-management.profile',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.customers', link: '/base-management/customers' },
            { name: 'base-management.profile' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-customers')) next();
          else next('/');
        },
      },

      // Registration Culture
      {
        path: 'base-management/registration-culture',
        name: 'base-registration-culture',
        component: RegistrationCulture,
        meta: {
          title: 'base-management.base-registration-culture',
          breadcrumb: [{ name: 'base-management.index' }, { name: 'base-management.base-registration-culture' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-registration-culture')) {
            next();
          } else {
            next('/');
          }
        },
      },

      // Start Personas
      {
        path: 'base-management/personas',
        name: 'base-personas',
        component: Personas,
        meta: {
          title: 'base-management.personas',
          breadcrumb: [{ name: 'base-management.index' }, { name: 'personas.list', link: '/base-management/personas' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-personas')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/personas/view/:id',
        name: 'PersonaView',
        component: PersonasDetail,
        props: route => ({ mode: 'view', id: route.params.id }),
        meta: {
          title: 'base-management.view-persona',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'personas.list', link: '/base-management/personas' },
            { name: 'personas.detail' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-personas')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/personas/:id/compare',
        name: 'personasCompareId',
        props: route => ({ id: route.params.id }),
        component: PersonasCompare,
        meta: {
          title: 'base-management.personas-compare',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'personas.list', link: '/base-management/personas' },
            { name: 'personas.compare' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-personas')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/personas/create',
        name: 'PersonaCreate',
        component: PersonasDetail,
        props: {
          mode: 'create',
        },
        meta: {
          title: 'base-management.create-persona',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'personas.list', link: '/base-management/personas' },
            { name: 'personas.create' },
          ],
        },
      },
      {
        path: 'base-management/personas/create/:id',
        name: 'PersonaDuplicate',
        component: PersonasDetail,
        props: route => ({ mode: 'create', id: route.params.id }),
        meta: {
          title: 'base-management.duplicate-persona',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'personas.list', link: '/base-management/personas' },
            { name: 'personas.duplicate' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-personas')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/personas/compare',
        name: 'audiences-personas-compare',
        component: PersonasCompare,
        meta: {
          title: 'base-management.personas-compare',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'personas.list', link: '/base-management/personas' },
            { name: 'personas.compare' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-personas')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/personas/:id/dashboard',
        name: 'personasDashboard',
        component: PersonasDashboard,
        meta: {
          title: 'base-management.painel-persona',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'personas.list', link: '/base-management/personas' },
            { name: 'personas.dashboard' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-personas')) next();
          else next('/');
        },
      },
      // End personas

      // Start Rfv
      {
        path: 'base-management/rfv',
        name: 'rfv',
        component: Rfv,
        meta: {
          title: 'base-management.rfv',
          breadcrumb: [{ name: 'base-management.index' }, { name: 'base-management.rfv' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'rfv')) next();
          else next('/');
        },
      },

      // Start Customer Distribution
      {
        path: 'base-management/customer-distribution',
        name: 'customer-distribution',
        component: CustomerDistribution,
        meta: {
          title: 'base-management.customer-distribution',
          breadcrumb: [{ name: 'base-management.index' }, { name: 'base-management.customer-distribution' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'customer-distribution')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/customer-distribution/:id',
        name: 'CustomerDistributionEdit',
        component: CustomerDistributionEdit,
        props: route => ({ id: route.params.id }),
        meta: {
          title: 'base-management.customer-distribution-edit',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'base-management.customer-distribution', link: '/base-management/customer-distribution' },
            { name: 'base-management.customer-distribution-edit' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'customer-distribution')) next();
          else next('/');
        },
      },

      // Labels
      {
        path: 'base-management/labels',
        name: 'base-labels',
        component: Labels,
        meta: {
          title: 'base-management.labels',
          breadcrumb: [{ name: 'base-management.index' }, { name: 'labels.list', link: '/base-management/labels' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-labels')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/labels/create',
        name: 'LabelCreate',
        component: LabelDetail,
        props: {
          mode: 'create',
        },
        meta: {
          title: 'base-management.create-label',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'labels.list', link: '/base-management/labels' },
            { name: 'labels.create' },
          ],
        },
      },
      {
        path: 'base-management/labels/create/:id',
        name: 'LabelsDuplicate',
        component: LabelDetail,
        props: route => ({ mode: 'create', id: route.params.id }),
        meta: {
          title: 'base-management.duplicate-label',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'labels.list', link: '/base-management/labels' },
            { name: 'labels.duplicate' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-labels')) next();
          else next('/');
        },
      },
      {
        path: 'base-management/labels/view/:id',
        name: 'LabelView',
        component: LabelDetail,
        props: route => ({ mode: 'view', id: route.params.id }),
        meta: {
          title: 'base-management.view-label',
          breadcrumb: [
            { name: 'base-management.index' },
            { name: 'labels.list', link: '/base-management/labels' },
            { name: 'labels.detail' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('base-management', 'base-labels')) next();
          else next('/');
        },
      },
      // End Labels
      //// End Base Management

      //// Start Help
      // Start Reports
      {
        path: '/help/reports',
        name: 'reports',
        component: ReportsList,
        meta: {
          title: 'help.reports',
          breadcrumb: [{ name: 'help.index' }, { name: 'help.reports.list', link: '/help/reports' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('help', 'reports')) next();
          else next('/');
        },
      },
      {
        path: '/help/reports/:id',
        name: 'reportDetail',
        component: Reports,
        meta: {
          title: 'help.reports',
          breadcrumb: [
            { name: 'help.index' },
            { name: 'help.reports.list', link: '/help/reports' },
            { name: 'help.reports.detail' },
          ],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchRoutes('help', 'reports')) next();
          else next('/');
        },
      },
      // End Reports

      {
        path: 'help/glossary',
        name: 'glossary',
        component: Glossary,
        meta: {
          title: 'help.glossary',
          breadcrumb: [{ name: 'help.index' }, { name: 'help.glossary' }],
        },
        beforeEnter: (_to, _from, next) => {
          if (hasMatchSubRoutes('help', 'glossary')) next();
          else next('/');
        },
      },
      //// End Help

      // Start settings
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
        children: [
          {
            path: '',
            name: 'adm-preferences-root',
            component: Preferences,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.preferences' }],
            },
          },
          {
            path: 'preferences',
            name: 'adm-preferences',
            component: Preferences,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.preferences' }],
            },
          },
          {
            path: 'users',
            name: 'adm-users',
            component: Users,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.users' }],
            },
            beforeEnter: (to, from, next) => {
              if (hasMatchSubRoutes('settings', 'adm-users')) next();
              else next('/settings');
            },
            children: [
              {
                path: 'create',
                name: 'UserCreate',
                component: Users,
                meta: { isModal: true, title: 'settings' },
              },
              {
                path: 'edit/:id',
                name: 'UserEdit',
                component: Users,
                meta: { isModal: true, title: 'settings' },
              },
            ],
          },
          {
            path: 'metrics',
            name: 'adm-metrics',
            component: Metrics,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.metrics' }],
            },
            beforeEnter: (to, from, next) => {
              if (hasMatchSubRoutes('settings', 'adm-metrics')) next();
              else next('/settings');
            },
          },
          {
            path: 'stores',
            name: 'adm-stores',
            component: StoreSettings,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.stores.table' }],
            },
            beforeEnter: (to, from, next) => {
              if (hasMatchSubRoutes('settings', 'adm-stores')) next();
              else next('/settings');
            },
            children: [
              {
                path: '',
                name: 'adm-stores',
                component: StoreSettingsTable,
                props: { mode: 'create' },
                meta: {
                  title: 'settings',
                  breadcrumb: [
                    { name: 'settings.stores.table', link: '/settings/stores' },
                    { name: 'settings.stores.create' },
                  ],
                },
              },
              {
                path: 'create',
                name: 'adm-stores-create',
                component: StoresSettingsRegister,
                props: { mode: 'create' },
                meta: {
                  title: 'settings',
                  breadcrumb: [
                    { name: 'settings.stores.table', link: '/settings/stores' },
                    { name: 'settings.stores.create' },
                  ],
                },
              },
              {
                path: 'edit/:id',
                name: 'adm-stores-edit',
                component: StoresSettingsRegister,
                props: route => ({ mode: 'edit', id: route.params.id }),
                meta: {
                  title: 'settings',
                  breadcrumb: [
                    { name: 'settings.stores.table', link: '/settings/stores' },
                    { name: 'settings.stores.edit' },
                  ],
                },
              },
              {
                path: ':id',
                name: 'adm-stores-duplicate',
                component: StoresSettingsRegister,
                props: route => ({ id: route.params.id }),
                meta: {
                  title: 'settings',
                  breadcrumb: [
                    { name: 'settings.stores.table', link: '/settings/stores' },
                    { name: 'settings.stores.duplicate' },
                  ],
                },
              },
            ],
          },
          {
            path: 'security',
            name: 'adm-security',
            component: Security,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.security' }],
            },
          },
          {
            path: 'integrations',
            name: 'adm-integrations',
            component: Integrations,
            props: route => ({ state: route.query.state }),
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.integrations' }],
            },
            beforeEnter: (to, from, next) => {
              if (hasMatchSubRoutes('settings', 'adm-integrations')) next();
              else next('/settings');
            },
            children: [
              {
                path: 'create',
                name: 'CreateIntegration',
                component: IntegrationCreateEdit,
                meta: { isModal: true },
              },
              {
                path: 'edit/:id',
                name: 'Editintegration',
                component: IntegrationCreateEdit,
                meta: { isModal: true },
              },
              {
                path: ':id',
                name: 'IntegrationState',
                component: Integrations,
              },
            ],
          },
          {
            path: 'limits',
            name: 'adm-limits',
            component: Limits,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.limits' }],
            },
            beforeEnter: (to, from, next) => {
              if (hasMatchSubRoutes('settings', 'adm-limits')) next();
              else next('/settings');
            },
          },
          {
            path: 'custom-fields',
            name: 'adm-custom-fields',
            component: CustomFields,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.custom-fields' }],
            },
            beforeEnter: (to, from, next) => {
              if (hasMatchSubRoutes('settings', 'adm-custom-fields')) next();
              else next('/settings');
            },
          },
          {
            path: 'send-usage',
            name: 'adm-send-usage',
            component: SendUsage,
            meta: {
              title: 'settings',
              breadcrumb: [{ name: 'settings.limits' }],
            },
            beforeEnter: (to, from, next) => {
              next();
              // if (hasMatchSubRoutes('settings', 'adm-limits')) next();
              // else next('/settings');
            },
          },
        ],
      },
      // End settings
    ],
    beforeEnter: (to, from, next) => {
      if (!store.getters.isLoggedIn) {
        store.dispatch('logout');
      } else if (store.getters.ready || store.getters.ready === null) {
        next();
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginOto,
    meta: {
      title: 'login',
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.isLoggedIn) {
        next('/');
      } else {
        next();
      }
    },
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      // Check if federation is set
      let logoutRedirect;
      if (store.getters.user) {
        const { federation } = store.getters.user;
        if (federation && federation.logoutUrl) {
          logoutRedirect = federation.logoutUrl;
        }
      }

      store.dispatch('logout');

      // Sign out user from SSO
      if (logoutRedirect) {
        window.location.href = logoutRedirect;
      }

      next('/login');
    },
  },
  {
    path: '/login-360',
    name: 'login-360',
    component: AppLogin360,
    meta: { title: 'login-360' },
  },
  {
    path: '/:catchAll(.*)',
    beforeEnter: (to, from, next) => {
      next('/login');
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    else if (!to.meta.isModal && !from.meta.isModal) return { x: 0, y: 0 };
    return false;
  },
});

export default router;
